function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { decl, bool2string } from '@yandex-lego/i-bem-react';
import "./../../control/control.react.js";
import _control from "./../../../desktop.blocks/control/control.react.js";

var Control = _control.applyDecls();

import "./../../icon/icon.react.js";
import "./../../icon/_glyph/icon_glyph.react.js";
import _icon_glyph_xSign from "./../../icon/_glyph/icon_glyph_x-sign.react.js";

var Icon = _icon_glyph_xSign.applyDecls();

import "./../../icon/icon.css";
import "./../../icon/_type/icon_type_cross.css";
import "./../../icon/_glyph/icon_glyph.css";
import "./../../icon/_glyph/icon_glyph_x-sign.css";
export default decl(Control, {
  block: 'textarea',
  elem: 'clear',
  iconType: function iconType() {},
  iconGlyph: function iconGlyph() {},
  mods: function mods(_ref) {
    var theme = _ref.theme,
        visible = _ref.visible;
    return _objectSpread({}, this.__base.apply(this, arguments), {
      theme: theme,
      visible: bool2string(visible)
    });
  },
  render: function render() {
    var block = this.block,
        elem = this.elem;
    return React.createElement(Icon, {
      type: this.iconType(this.props),
      glyph: this.iconGlyph(this.props),
      attrs: this.attrs(this.props),
      mix: {
        block: block,
        elem: elem,
        mods: this.mods(this.props)
      }
    });
  }
});